export default __webpack_public_path__ + "static/media/discipline_icon.18536bf5.webp";